import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { InputValidators } from '../inputs.interface';

@Component({
  selector: 'hospitable-validation-message',
  templateUrl: './validation-message.component.html',
  styleUrls: ['./validation-message.component.scss'],
})
export class ValidationMessageComponent {
  @Input() control: AbstractControl;
  @Input() validators: InputValidators[];
}
